import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  FiCheck,
  FiChevronDown,
  FiCreditCard,
  FiFolder,
  FiPlus,
  FiRepeat,
  FiUser,
} from "react-icons/fi";
import { FaWhatsapp } from "react-icons/fa";
import { BsBuilding } from "react-icons/bs";
import TopBar, { useOutsideClose } from "../dashboard/TopBar";
import { setActiveCompany } from "../../redux/actions/CompanyActions";
import { addToCart, clearCart } from "../../redux/actions/CartActions";
import { clearServiceList } from "../../redux/actions/ServiceListActions";
import { clearRequest } from "../../redux/actions/RequestActions";

const WHATSAPP_URL = "https://wa.me/237677200200";

const UserNavbar = ({ toggleSidebar }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userCompanies, activeCompany } = useSelector(
    (state) => state.companies,
  );
  const [companiesOpen, setCompaniesOpen] = useState(false);
  const companiesRef = useOutsideClose(companiesOpen, setCompaniesOpen);

  // A new creation starts from a clean order
  const startCreation = async () => {
    setCompaniesOpen(false);
    await dispatch(clearCart());
    await dispatch(clearServiceList());
    await dispatch(clearRequest());
    await dispatch(addToCart({ from: "creation" }));
    navigate("/business-country");
  };

  const companySelector = activeCompany ? (
    <div className="dash-dropdown" ref={companiesRef}>
      <button
        type="button"
        className="dash-company"
        aria-haspopup="menu"
        aria-expanded={companiesOpen}
        onClick={() => setCompaniesOpen((open) => !open)}
      >
        <BsBuilding aria-hidden="true" />
        <span className="dash-company-name">{activeCompany.businessName}</span>
        <FiChevronDown aria-hidden="true" />
      </button>

      {companiesOpen && (
        <div className="dash-menu is-left" role="menu">
          {userCompanies.map((company) => {
            const active = company._id === activeCompany._id;

            return (
              <button
                key={company._id}
                type="button"
                role="menuitem"
                className="dash-menu-item"
                onClick={() => {
                  dispatch(setActiveCompany(company));
                  setCompaniesOpen(false);
                }}
              >
                <span className="dash-menu-check" aria-hidden="true">
                  {active && <FiCheck />}
                </span>
                {company.businessName}
              </button>
            );
          })}
          <button
            type="button"
            role="menuitem"
            className="dash-menu-item is-accent"
            onClick={startCreation}
          >
            <FiPlus aria-hidden="true" /> Créer une entreprise
          </button>
        </div>
      )}
    </div>
  ) : (
    <button type="button" className="dash-button" onClick={startCreation}>
      <FiPlus aria-hidden="true" /> Créer une entreprise
    </button>
  );

  return (
    <TopBar
      toggleSidebar={toggleSidebar}
      left={companySelector}
      right={
        <a
          className="dash-help"
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaWhatsapp aria-hidden="true" />
          <span>Besoin d'aide ?</span>
        </a>
      }
      menuItems={[
        { label: "Mon profil", icon: FiUser, to: "/user/profile" },
        { label: "Mes documents", icon: FiFolder, to: "/user/mydocuments" },
        { label: "Abonnements", icon: FiRepeat, to: "/user/subscriptions" },
        {
          label: "Paiements",
          icon: FiCreditCard,
          to: "/user/transaction-history",
        },
      ]}
    />
  );
};

export default UserNavbar;
